import { render, staticRenderFns } from "./StepRoofSize.vue?vue&type=template&id=5685d9c4&"
import script from "./StepRoofSize.vue?vue&type=script&lang=js&"
export * from "./StepRoofSize.vue?vue&type=script&lang=js&"
import style0 from "./StepRoofSize.vue?vue&type=style&index=0&id=5685d9c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports